<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Venues"></side-menu>
    <div class="content">
      <div class="dashboard">
        <heading :title="'Venues'"></heading>

        <button @click="openPopup" class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Venue
        </button>

        <div class="agendas">
          <div class="agenda">
            <!-- <div class="date">
              <p>Monday, May 25, 2020</p>
            </div>-->

            <table>
              <thead>
                <td>Name</td>
                <td>Areas</td>
                <td>Address 1</td>
                <td>Address 2</td>
                <td>City</td>
                <td>State</td>
                <td>Country</td>
                <td>Zip</td>
                <td>Action</td>
              </thead>

              <tbody>
                <tr v-for="venue in venues" :key="venue.id">
                  <td class="company" data-label="Address 1">
                    {{ venue.name }}
                  </td>
                  <td class="company" data-label="Address 1">
                    <p v-for="(area, index) in venue.areas" :key="index">
                      {{ area }}
                    </p>
                  </td>
                  <td class="company" data-label="Address 1">
                    {{ venue.address_1 }}
                  </td>
                  <td class="company" data-label="Address 2">
                    {{ venue.address_2 }}
                  </td>
                  <td class="company" data-label="City">{{ venue.city }}</td>
                  <td class="company" data-label="State">{{ venue.state }}</td>
                  <td class="description" data-label="Country">
                    {{ venue.country }}
                  </td>
                  <td class="company" data-label="Zip">{{ venue.zip }}</td>
                  <td data-label="Action">
                    <div class="settings">
                      <img
                        @click="deleteVenue(venue.id)"
                        src="@/assets/img/trash.svg"
                      />
                      <img
                        @click="editVenue(venue)"
                        src="@/assets/img/settings.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="card" v-for="session in sessions" :key="session.id">
              <p class="title">Title: {{ session.title }}</p>
              <p class="company">Start Time: {{ session.start_time | format_date_time }}</p>
              <p class="company">End Time: {{ session.end_time | format_date_time }}</p>
              <p class="description">
                Panelists:
                {{ formatArray(session, "panelists", "display_name") }}
              </p>
              <p class="description">Description: {{ session.description }}</p>
              <div class="controls">
                <img @click="deleteAgenda(session.id)" src="@/assets/img/trash.svg" />
                <img @click="editAgenda(session)" src="@/assets/img/settings.svg" />
              </div>
            </div>-->
            <popup title="Add A Venue" :show="showPopup">
              <g-address
                :inputAddress="venue"
                @autoCompleteAddress="updateAddress"
              >
                <div class="input">
                  <label>Name <span>*</span></label>
                  <input type="text" v-model="venue.name" />
                  <!-- <v-select
                    :value="venue.name"
                    @input="handleVenueSelect"
                    label="name"
                    :options="venues"
                    taggable
                    :create-option="
                      (venue) => ({
                        name: venue,
                        areas: [],
                        address_1: null,
                        address_2: null,
                        address_3: null,
                        zip: null,
                        city: null,
                        state: null,
                        country: null,
                        map: null,
                      })
                    "
                  ></v-select> -->
                </div>
                <div class="input">
                  <label
                    >Areas/Sections <span>*</span>
                    <sub>(Press "Enter" to save)</sub>
                  </label>
                  <input
                    type="text"
                    placeholder="Seperate with a comma for multiples"
                    @keypress="addAreaToVenue($event, venue)"
                  />
                  <div v-for="(area, index) in venue.areas" :key="index">
                    <p>
                      {{ area }}
                      <span
                        style="cursor: pointer; color: red"
                        @click="removeArea(venue, index)"
                      >
                        x</span
                      >
                    </p>
                  </div>
                </div>
              </g-address>
              <div class="btns">
                <button @click="closePopup" class="btn text_btn">Cancel</button>
                <button @click="addVenue" class="btn">Save</button>
                <div v-if="error" class="error">
                  {{ error }}
                </div>
              </div>
            </popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import GoogleAddress from "@/components/Tools/GoogleAddress.vue";
import Popup from "@/components/Popup.vue";
import Title from "@/components/Title.vue";
import { Datetime } from "vue-datetime";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;

var moment = require("moment");
import firebase from "firebase";
export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    "g-address": GoogleAddress,
  },
  data() {
    return {
      showPopup: false,
      venue: {
        name: null,
        areas: [],
        address_1: null,
        address_2: null,
        address_3: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        map: null,
      },
      venues: [],
      error: null,
    };
  },
  firestore() {
    return {
      venues: db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues"),
    };
  },
  methods: {
    // handleVenueSelect(item) {
    //   this.venue = item;
    //   if (!item.id) {
    //     this.openPopup();
    //   }
    // },
    addAreaToVenue(e, venue) {
      if (e.code == "Enter") {
        let values = e.target.value.split(",");
        values.forEach((v) => {
          v = v.trim();
          if (v) {
            venue.areas.push(v);
          }
        });
        e.target.value = null;
      }
    },
    removeArea(venue, index) {
      venue.areas.splice(index, 1);
    },
    openPopup() {
      this.showPopup = true;
      this.venue.id = db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues")
        .doc().id;
    },
    closePopup() {
      this.showPopup = false;
      this.venue = {
        address_1: null,
        address_2: null,
        address_3: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        map: null,
      };
    },
    updateAddress(payload) {
      this.venue = Object.assign(this.venue, payload);
    },
    validInputs() {
      if (
        !this.venue.name ||
        !this.venue.address_1 ||
        !this.venue.city ||
        !this.venue.state ||
        !this.venue.country ||
        !this.venue.zip
      ) {
        return false;
      }
      return true;
    },
    addVenue() {
      if (!this.validInputs()) {
        this.error = "Missing required fields.";
        setTimeout(() => {
          this.error = null;
        }, 3000);
        return;
      }
      db.collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues")
        .doc(this.venue.id)
        .set(this.venue, { merge: true })
        .then(() => {
          this.showPopup = false;
          this.venue = {
            name: null,
            areas: [],
            address_1: null,
            address_2: null,
            address_3: null,
            zip: null,
            city: null,
            state: null,
            country: null,
            map: null,
          };
        });
    },
    deleteVenue(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          db.collection("user")
            .doc(auth.currentUser.uid)
            .collection("venues")
            .doc(id)
            .delete();
        }
      });
    },
    editVenue(venue) {
      this.venue = venue;
      this.showPopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  .inputs {
    height: 345px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px 30px 10px;
  }
  .input {
    width: 48%;
    input {
      padding: 10px !important;
    }
  }
  .error {
    font-weight: bold;
    color: red;
  }
}
</style>
